export default __webpack_public_path__ + "static/media/ss-gizmo.e88d392f.woff";